export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand-mark" aria-label="MOLA Dive Ready">
      <svg viewBox="0 0 52 34" aria-hidden="true">
        <path d="M3 8c7-7 14 7 23 0s16 7 23 0M3 17c7-7 14 7 23 0s16 7 23 0M3 26c7-7 14 7 23 0s16 7 23 0" />
      </svg>
      {!compact && <span>MOLA Dive Ready</span>}
    </div>
  );
}
